export const contactTranslations = {
  es: {
    contact: {
      title: "Contactanos",
      subtitle: "¿Quieres saber cómo partir?",
      description: "Estamos aquí para responder a tus preguntas y discutir cómo podemos ayudarte a transformar tu práctica médica con soluciones de IA avanzadas.",
      location: "Santiago, Chile",
      email: "info@intelimed.ai",
      form: {
        name: "Nombre",
        namePlaceholder: "Ej: Juan Pérez",
        institution: "Clínica/Hospital",
        institutionPlaceholder: "Centro de Salud",
        email: "Correo Electrónico",
        emailPlaceholder: "correo@institución.cl",
        message: "Mensaje",
        messagePlaceholder: "Cuéntenos sobre sus objetivos clínicos con IA...",
        submit: "Enviar Consulta",
        submitting: "Enviando...",
        errors: {
          nameRequired: "El nombre es obligatorio",
          emailRequired: "El correo es obligatorio",
          emailInvalid: "Ingresa un correo válido",
          messageRequired: "El mensaje es obligatorio",
          submitError: "Error al enviar. Intente nuevamente."
        }
      },
      success: {
        title: "¡Mensaje enviado!",
        message: "Gracias por contactarnos. Te responderemos a la brevedad."
      }
    }
  },
  en: {
    contact: {
      title: "Contact Us",
      subtitle: "Want to know how to get started?",
      description: "We're here to answer your questions and discuss how we can help you transform your medical practice with advanced AI solutions.",
      location: "Santiago, Chile",
      email: "info@intelimed.ai",
      form: {
        name: "Name",
        namePlaceholder: "e.g., John Doe",
        institution: "Clinic/Hospital",
        institutionPlaceholder: "Health Center",
        email: "Email Address",
        emailPlaceholder: "email@institution.com",
        message: "Message",
        messagePlaceholder: "Tell us about your clinical goals with AI...",
        submit: "Send Inquiry",
        submitting: "Sending...",
        errors: {
          nameRequired: "Name is required",
          emailRequired: "Email is required",
          emailInvalid: "Enter a valid email address",
          messageRequired: "Message is required",
          submitError: "Failed to send. Please try again."
        }
      },
      success: {
        title: "Message sent!",
        message: "Thank you for reaching out. We'll get back to you shortly."
      }
    }
  }
};
